import { TService } from '../../types/services';
import { IState } from '../reducers/createReviewData';
import {
  selectCurrentOrganization,
  selectCurrentProduct,
  selectCurrentReviewId,
  selectCurrentService,
  selectProductList,
  selectServiceList,
} from '../selectors/createReviewData';

import { useAppSelector } from './redux';

export const useProductList = (): IState['productList'] => useAppSelector(selectProductList);

export const useServiceList = (): IState['serviceList'] => useAppSelector(selectServiceList);

export const useCurrentProduct = (): IState['product'] => useAppSelector(selectCurrentProduct);

export const useCurrentOrganization = (): IState['organization'] => useAppSelector(selectCurrentOrganization);

export const useCurrentService = (): TService => useAppSelector(selectCurrentService);

export const useCurrentReviewId = (): IState['reviewId'] => useAppSelector(selectCurrentReviewId);
